import { Button, CircularProgress, Divider, MenuItem, Modal, Select, Switch, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StockCard from "components/ui/StockCard";
import addUsp from "assets/setting/addusp.png";
import toggleImage from "assets/setting/toggleImage.png";
import { useEffect, useRef, useState } from "react";
import uploadIcon from "assets/setting/uploadIcon.svg";
import MediaUploadModal from "./MediaUploadModal";
import DeleteIcon from "assets/setting/DeleteIcon.png";
import PreviewVideo from "./PreviewVideo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import USPCard from "./USPCard";
import MediaSelect from "./MediaSelect";
import { useUSPDesignQuery } from "./API/getUspDesignApi";
import { transformUspData } from "utils/transformdata";
import { useGetExcatDesign } from "./API/addBtnApi";
import { useUpdateUSPData } from "./API/useUpdateUSPDesign";
import { toast, ToastContainer } from "react-toastify";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { useSettingContext } from "context/SettingContext";
import { useGlobalContext } from "context/GlobalContext";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getIcon } from "utils/iconsConfig";

import { ReactComponent as PrevIcon } from "assets/icons/ArrowPrev.svg";
import { ReactComponent as NextIcon } from "assets/icons/ArrowNext.svg";
const EditUSPDetails = () => {
  const location = useLocation();
  const { jewelCode } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const isEdit = queryParams.get("isEdit") === "true";
  const selectedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];

  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={{ ...style, left: "-27px", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClick}>
        <PrevIcon />
      </div>
    );
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div className={className} style={{ ...style, right: "-15px", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClick}>
        <NextIcon />
      </div>
    );
  };

  const settings = {
    dots: true, // enable dots
    infinite: false, // prevent infinite scroll
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true, // show left/right arrows
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 768, // responsive for tablets/phones
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  console.log("isEdit:", isEdit);
  const [textAreaInput, setTextAreaInput] = useState("");
  const [uspMessage, setUspMessage] = useState("");

  const navigate = useNavigate();
  const [showToggleImage, setShowToggleImage] = useState(true);
  const [selectValue, setSelectValue] = useState("");
  const [openImageModal, setOpenImageModal] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);

  const [uploadedImages, setUploadedImages] = useState([]);
  const [modalImages, setModalImages] = useState([]);
  const [modalVideos, setModalVideos] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [videoURLs, setVideoURLs] = useState([]);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [dragImageIndex, setDragImageIndex] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isUspMsg, setIsUspMsg] = useState(false);
  const { mutate: updateUSP } = useUpdateUSPData();

  const handleImageDrop = (index) => {
    if (dragImageIndex === null || dragImageIndex === index) return;
    const reordered = [...uploadedImages];
    const [movedImage] = reordered.splice(dragImageIndex, 1);
    reordered.splice(index, 0, movedImage);
    setUploadedImages(reordered);
    setDragImageIndex(null);
  };

  useEffect(() => {
    // Clean up old URLs
    videoURLs.forEach((url) => URL.revokeObjectURL(url));
    const urls = uploadedVideos.map(
      (file) => (file instanceof File ? URL.createObjectURL(file) : file) // keep S3 URLs as-is
    );

    setVideoURLs(urls);

    // Revoke only the newly created object URLs
    return () => {
      urls.forEach((url, index) => {
        if (uploadedVideos[index] instanceof File) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [uploadedVideos]);

  const handleOpenImageModal = () => {
    setModalImages(uploadedImages);
    setOpenImageModal(true);
  };

  const handleSaveImages = () => {
    setUploadedImages(modalImages);
    setOpenImageModal(false);
  };

  const handleOpenVideoModal = () => {
    setModalVideos(uploadedVideos);
    setOpenVideoModal(true);
  };

  const handleSaveVideos = () => {
    setUploadedVideos(modalVideos);
    setOpenVideoModal(false);
  };

  const handleToggleChange = () => {
    setShowToggleImage(!showToggleImage);
  };
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectValue(value);
    if (value === "add image") {
      handleOpenImageModal();
      setSelectValue("");
    }
    if (value === "add video") {
      handleOpenVideoModal();
      setSelectValue("");
    }
  };

  const handleSaveChanges = () => {
    const formData = new FormData();
    setIsSaving(true);
    let design = selectedDesigns.length > 0 ? selectedDesigns.map((obj) => obj?.designNumber) : [jewelCode];

    formData.append("styleNumbers", design.join(","));
    formData.append("msg", uspMessage);

    const newImages = uploadedImages.filter((img) => typeof img !== "string");
    const newVideos = uploadedVideos.filter((vdo) => typeof vdo !== "string");

    newImages.forEach((img) => formData.append("images", img));
    newVideos.forEach((vdo) => formData.append("videos", vdo));

    const existingImages = uploadedImages.filter((img) => typeof img === "string");
    formData.append("existingImages", existingImages.join(","));

    const existingVideos = uploadedVideos.filter((vdo) => typeof vdo === "string");
    formData.append("existingVideos", existingVideos.join(","));

    updateUSP(formData, {
      onSuccess: (data) => {
        toast.success("Updated Successfully", { autoClose: 1000 });

        setTimeout(() => {
          setIsSaving(false);
          localStorage.setItem("refetchUSP", "true");
          window.close() || navigate("/Setting/product-usp-and-gallery");
        }, 1000);
      },
      onError: () => {
        alert("Update Failed");
        setIsSaving(false);
      },
    });
  };

  useEffect(() => {
    setSelectValue("");
  }, []);

  // ---- API Call ----\\
  const { data: uspCardData } = useGetExcatDesign(jewelCode);

  const { data: uspDesign, isLoading, isError } = useUSPDesignQuery(jewelCode);

  useEffect(() => {
    if (uspDesign) {
      setTextAreaInput(uspDesign.uspMsg);
      setUploadedImages(uspDesign.images);
      setUploadedVideos(uspDesign.videos);
      setUspMessage(uspDesign.uspMsg);
    }
  }, [uspDesign]);

  return (
    <Box>
      {isSaving && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(44, 42, 42, 0.6)", // transparent white
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={50} thickness={4} sx={{ color: "#50C878" }} />
        </Box>
      )}

      <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: "100%", marginRight: "-20px" }} />
      {/* Main Container */}
      <Box sx={{ display: "flex", flexDirection: "row", width: "100%" }}>
        {/* left Continer */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {/* Header part */}
          <Box
            sx={{
              marginBottom: "1.458vw",
              marginTop: "1.667vw",
              marginRight: "1.667vw",
              width: "62.2vw",
              height: "3vw",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "1.67vw",
            }}
          >
            <h2
              style={{
                fontFamily: "Poppins",
                fontSize: "1.2vw",
                lineHeight: "1.875vw",
                fontWeight: 500,
              }}
            >
              {isEdit ? "Edit USP & Gallery" : "Add USP & Gallery"}
            </h2>

            <Box
              // sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "216px", height: "42px", border: "1px solid blue" }}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "14.5vw",
                height: "2.9vw",
                gap: "1vw",
              }}
            >
              <button
                onClick={() => handleSaveChanges()}
                style={{
                  border: "0.1vw solid #50C878",
                  color: "#50C878",
                  width: "11vw",
                  height: "2.7vw",
                  borderRadius: "0.5vw",
                  fontFamily: "Poppins",
                  fontSize: "1.1vw",
                  fontWeight: 500,
                  lineHeight: "1.15vw",
                  letterSpacing: "-0.41px", // keep as is unless scaling typography
                  textTransform: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              >
                Save Changes
              </button>
              <IconButton
                sx={{ width: "2.5vw", height: "2.5vw", border: "0.1vw solid #8B8B8B", borderRadius: "0.21vw" }}
                aria-label="close"
                onClick={() => window.close() || navigate("/product-usp-and-gallery")}
              >
                <CloseIcon sx={{ width: "1.5vw", height: "2.5vw", color: "#8B8B8B" }} />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ maxHeight: "76vh", overflow: "auto", scrollbarWidth: "thin", scrollbarColor: "#999 transparent", top: 0, zIndex: 10, background: "#000" }}>
            {/* USP Card and Msg part */}
            <Box sx={{ paddingLeft: isEdit ? "1.67vw" : "none", display: "flex", gap: isEdit ? "1.50vw" : "2.5vw", width: "62.2vw" }}>
              {!isEdit ? (
                <Box
                  sx={{
                    width: "50%",
                    display: "flex",
                    gap: "1vw",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ paddingLeft: "1.67vw", display: "flex", width: "100%", height: "1.9vw", justifyContent: "space-between", alignItems: "center" }}>
                    <h5 style={{ fontSize: "1vw", fontFamily: "Poppins", fontWeight: 500 }}>Design - {selectedDesigns.length}</h5>
                  </Box>

                  <Box sx={{ paddingLeft: "1.67vw", display: "flex", flexDirection: "column", gap: "1vw", overflow: "visible", position: "relative", zIndex: 1 }}>
                    <Slider {...settings} style={{ overflow: "visible" }}>
                      {selectedDesigns.map((design, index) => (
                        <USPCard key={index} data={design} />
                      ))}
                    </Slider>
                  </Box>
                </Box>
              ) : (
                <Box>{uspCardData ? <USPCard data={transformUspData(uspCardData)} /> : <ProductSkeleton />}</Box>
              )}

              <Box sx={{ width: "31vw", height: !isEdit ? "37.5vh" : "31.5vh", display: "flex", flexDirection: "column", gap: "1.30vw" }}>
                <Box sx={{ display: "flex", width: "100%", height: "1.9vw", justifyContent: "space-between", alignItems: "center" }}>
                  <h5 style={{ fontSize: "1vw", fontFamily: "Poppins", fontWeight: 500 }}>Product USP</h5>
                  <button
                    style={{
                      backgroundColor: isUspMsg ? "#50C878" : "#3D3D3D",
                      border: "none",
                      color: isUspMsg ? "black" : "#8E8E93",
                      width: "5.32vw",
                      height: "1.8vw",
                      borderRadius: "0.4vw",
                      padding: "0.50vw",
                      fontSize: "0.8vw",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUspMessage(textAreaInput);
                      setIsUspMsg(false);
                    }}
                  >
                    Save USP
                  </button>
                </Box>

                <textarea
                  placeholder="Enter USP message..."
                  value={textAreaInput}
                  onChange={(e) => {
                    const value = e.target.value;
                    setTextAreaInput(value);
                    if (value !== uspMessage) {
                      setIsUspMsg(true);
                    } else {
                      setIsUspMsg(false);
                    }
                  }}
                  style={{
                    width: "100%",
                    minHeight: isEdit ? "24.6vh" : "30.5vh",
                    maxHeight: isEdit ? "24.6vh" : "30.5vh",
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#999 transparent",
                    border: "0.1vw solid #8080808C",
                    borderRadius: "0.6vw",
                    padding: "1rem",
                    fontSize: "0.91vw",
                    fontFamily: "poppins",
                    resize: "none",
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                    backgroundColor: "#000",
                    color: "#fff",
                    outline: "none",
                  }}
                />
              </Box>
            </Box>

            {/* Sub Header part */}

            <Box
              sx={{
                paddingLeft: "1.67vw",
                display: "flex",
                justifyContent: "space-between",
                marginRight: "1.667vw",
                marginTop: "1.667vw",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box>
                <h5
                  style={{
                    fontSize: "1.2vw",
                    fontWeight: 500,
                    fontFamily: "Poppins",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  Product Gallery
                </h5>
                <p style={{ color: "#8B8B8B", margin: 0, fontSize: "0.91vw" }}>
                  {(uploadedVideos.length > 0 || uploadedImages.length > 0) && (
                    <>
                      ({uploadedVideos.length > 0 && `${uploadedVideos.length} Video${uploadedVideos.length > 1 ? "s" : ""}`}
                      {uploadedVideos.length > 0 && uploadedImages.length > 0 && " & "}
                      {uploadedImages.length > 0 && `${uploadedImages.length} Image${uploadedImages.length > 1 ? "s" : ""}`})
                    </>
                  )}
                </p>
              </Box>

              <MediaSelect handleSelectChange={handleSelectChange} selectValue={selectValue} from={isEdit ? "Edit" : "Add"} />
            </Box>

            {uploadedImages.length === 0 && uploadedVideos.length === 0 && (
              // here
              <Box sx={{ paddingLeft: "1.67vw", display: "flex", justifyContent: "center" }}>
                <img src={addUsp} width="230vw" height="190vw" />
              </Box>
            )}
            {/* Images videos part */}
            {/* here */}
            <Box sx={{ paddingLeft: "1.67vw", marginRight: "1.667vw", position: "sticky", top: 0, zIndex: 10, background: "#000" }}>
              {/* Display uploaded videos (no drag) */}
              {uploadedVideos.map((file, idx) => (
                <Box
                  key={`video-${idx}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    py: 1,
                    borderBottom: "1px solid #444444",

                    boxSizing: "border-box",
                  }}
                >
                  <video
                    // src={typeof file === "string" ? file : URL.createObjectURL(file)}
                    src={typeof file === "string" ? file : videoURLs[idx]}
                    style={{
                      borderRadius: 8,
                      objectFit: "cover",
                      border: "1px solid #ccc",
                      marginRight: 12,
                      width: "5.2vw",
                      height: "5.2vw",
                    }}
                  />

                  <span style={{ color: "#fff", flex: 1, marginRight: "0.8vw", fontSize: "1vw", fontFamily: "poppins" }}>{typeof file === "string" ? file.split("/").pop() : file.name}</span>
                  <IconButton
                    onClick={() => {
                      const updated = [...uploadedVideos];
                      const updatedURLs = [...videoURLs];
                      updated.splice(idx, 1);
                      updatedURLs.splice(idx, 1);
                      setUploadedVideos(updated);
                      setVideoURLs(updatedURLs);
                    }}
                    size="small"
                    sx={{ color: "#f44336" }}
                  >
                    {/* <img src={DeleteIcon} width="22px" height="22px" /> */}
                    <img src={DeleteIcon} style={{ width: "1.5vw", height: "1.5vw" }} />
                  </IconButton>
                </Box>
              ))}

              {/* Display uploaded images (draggable via 6-dot handle) */}
              {uploadedImages?.length > 0 &&
                uploadedImages?.map((file, idx) => (
                  <Box
                    key={`image-${idx}`}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={() => handleImageDrop(idx)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,

                      py: 1,
                      borderBottom: "1px solid #444444",
                    }}
                  >
                    {/* Drag handle (6-dot icon) */}
                    <span
                      draggable
                      onDragStart={() => setDragImageIndex(idx)}
                      style={{
                        marginRight: 12,
                        display: "flex",
                        alignItems: "center",
                        cursor: "grab",
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="#8B8B8B">
                        <circle cx="4" cy="4" r="1.5" />
                        <circle cx="4" cy="9" r="1.5" />
                        <circle cx="4" cy="14" r="1.5" />
                        <circle cx="10" cy="4" r="1.5" />
                        <circle cx="10" cy="9" r="1.5" />
                        <circle cx="10" cy="14" r="1.5" />
                      </svg>
                    </span>

                    {/* Image preview */}
                    <img
                      // src={URL.createObjectURL(file)}
                      src={typeof file === "string" ? file : URL.createObjectURL(file)}
                      alt={`uploaded-img-${idx}`}
                      // width={80}
                      // height={80}
                      style={{
                        borderRadius: 8,
                        objectFit: "cover",
                        border: "1px solid #ccc",
                        marginRight: 12,
                        width: "5.2vw",
                        height: "5.2vw",
                      }}
                    />

                    {/* File name */}
                    {/* <span style={{ color: "#fff", flex: 1, marginRight: 12 }}>{file.name}</span> */}
                    <span style={{ color: "#fff", flex: 1, marginRight: "0.8vw", fontSize: "1vw", fontFamily: "poppins" }}>{typeof file === "string" ? file.split("/").pop() : file.name}</span>

                    {/* Delete button */}
                    <IconButton
                      onClick={() => {
                        const updated = [...uploadedImages];
                        updated.splice(idx, 1);
                        setUploadedImages(updated);
                      }}
                      size="small"
                      sx={{ color: "#f44336" }}
                    >
                      <img src={DeleteIcon} style={{ width: "1.5vw", height: "1.5vw" }} />
                    </IconButton>
                  </Box>
                ))}
            </Box>
          </Box>
        </Box>

        <Divider orientation="vertical" flexItem sx={{ borderColor: "#101010", borderRightWidth: 5, mx: 0, alignSelf: "stretch" }} />
        {/* right Container */}
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%" }}>
          <Box sx={{ padding: "1vw", borderBottom: "5px solid #101010", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
            <h5 style={{ fontSize: "1vw", fontWeight: 400, fontFamily: "Poppins", margin: 0, padding: 0 }}>Preview</h5>
            <Switch color="success" onChange={handleToggleChange} />
          </Box>

          <Box sx={{ maxHeight: "78vh", overflow: "auto", scrollbarWidth: "thin", scrollbarColor: "#999 transparent", background: "#000" }}>
            {showToggleImage ? (
              <Box sx={{ display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center", height: "78vh" }}>
                <img src={toggleImage} style={{ width: "11vw", height: "13.5vw" }} />
              </Box>
            ) : (
              <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                {uspMessage.length > 0 && (
                  <Box
                    sx={{
                      width: "100%",
                      pl: "1vw",
                      pt: "0.75vw",
                      pr: "2vw",
                      pb: "1vw",
                      borderBottom: "0.3125vw solid #101010",
                    }}
                  >
                    <h6 style={{ margin: 0, padding: 0, fontSize: "0.875vw", fontWeight: 500, fontFamily: "Poppins", color: "#8b8b8b" }}>Product USP</h6>
                    <p
                      style={{
                        fontSize: "0.9vw",
                        fontWeight: 500,
                        fontFamily: "Poppins",
                        color: "#fff",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {uspMessage}
                    </p>
                  </Box>
                )}
                {uploadedVideos.length > 0 && (
                  <Box sx={{ color: "#fff", px: "0vw" }}>
                    <h6 style={{ fontSize: "0.875vw", fontFamily: "Poppins", fontWeight: 500, color: "#8B8B8B", paddingLeft: "1vw", margin: "1vw" }}>Product Videos</h6>
                    <Box sx={{ width: "full", display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                      {uploadedVideos.map((file, idx) => (
                        <PreviewVideo file={file} key={idx} />
                      ))}
                    </Box>
                  </Box>
                )}
                {uploadedImages.length > 0 && (
                  <Box sx={{ color: "#fff", px: "0vw" }}>
                    <h6 style={{ fontSize: "0.875vw", fontFamily: "Poppins", fontWeight: 500, color: "#8B8B8B", paddingLeft: "1vw", margin: "1vw" }}>Product Images</h6>
                    <Box sx={{ width: "full", display: "flex", flexDirection: "column", alignItems: "center", gap: "0.625vw" }}>
                      {uploadedImages.map((file, idx) => (
                        <img
                          key={idx}
                          src={typeof file === "string" ? file : URL.createObjectURL(file)}
                          style={{
                            width: "27.396vw",
                            height: "27.396vw",
                            objectFit: "cover",
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <MediaUploadModal
        open={openImageModal}
        onClose={() => setOpenImageModal(false)}
        files={modalImages}
        setFiles={setModalImages}
        selectedIndex={selectedImageIndex}
        setSelectedIndex={setSelectedImageIndex}
        accept="image/*"
        // title={`Edit Image ${jewelCode}`}
        title={isEdit ? "Edit Image" : "Add Image"}
        previewLabel="Product Images"
        uploadLabel="Upload Images | Drag & Drop | Browse Files"
        isImage={true}
        onSave={handleSaveImages}
        isEdit={isEdit}
      />

      <MediaUploadModal
        open={openVideoModal}
        onClose={() => setOpenVideoModal(false)}
        files={modalVideos}
        setFiles={setModalVideos}
        selectedIndex={selectedVideoIndex}
        setSelectedIndex={setSelectedVideoIndex}
        accept="video/*"
        // title={`Edit Video ${jewelCode}`}
        title={isEdit ? "Edit Video" : "Add Video"}
        previewLabel="Product Videos"
        uploadLabel="Upload Videos | Drag & Drop | Browse Files"
        isImage={false}
        onSave={handleSaveVideos}
        isEdit={isEdit}
        setUploadedVideos={setUploadedVideos}
        setVideoURLs={setVideoURLs}
        uploadedVideos={uploadedVideos}
      />
      <ToastContainer />
    </Box>
  );
};

export default EditUSPDetails;
